'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Label = require('../typography/Label');

var _Label2 = _interopRequireDefault(_Label);

require('./breadcrumb.scss');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function Breadcrumb(props) {
  var children = props.children;
  return _react2.default.createElement('nav', {
    className: 'breadcrumb-nav'
  }, children);
}

function Home(props) {
  var name = props.name,
      link = props.link;
  return _react2.default.createElement('li', {
    className: 'home-crumb'
  }, _react2.default.createElement('a', {
    href: link
  }, _react2.default.createElement(_Label2.default, {
    label: name
  })));
}

function PreviousLink(props) {
  var name = props.name,
      link = props.link;
  return _react2.default.createElement('li', {
    className: 'home-crumb'
  }, _react2.default.createElement('a', {
    href: link
  }, _react2.default.createElement(_Label2.default, {
    label: name
  })));
}

function Current(props) {
  var name = props.name;
  return _react2.default.createElement('li', {
    className: 'home-crumb'
  }, _react2.default.createElement(_Label2.default, {
    label: name
  }));
}

Breadcrumb.Home = Home;
Breadcrumb.History = PreviousLink;
Breadcrumb.Current = Current;
exports.default = Breadcrumb;
Breadcrumb.propTypes = {
  children: _propTypes2.default.node.isRequired
};
Home.propTypes = {
  name: _propTypes2.default.string.isRequired,
  link: _propTypes2.default.string.isRequired
};
PreviousLink.propTypes = {
  name: _propTypes2.default.string.isRequired,
  link: _propTypes2.default.string.isRequired
};
Current.protoTypes = {
  name: _propTypes2.default.string.isRequired
};